import sliceCreator from '../../index.js';
import {LOGIN_SEND_OTP} from '../../../constants/index.js';
const _loginSendOtpAction = sliceCreator('LOGIN_SEND_OTP', LOGIN_SEND_OTP, 'post');

const { asyncAction: loginSendOtpAction, reducer, clearData: clearLoginSendOtpAction } = _loginSendOtpAction;

export default reducer;

export {
    loginSendOtpAction,
    clearLoginSendOtpAction,
}


